const mindboxEvents = {
    EditCustomer: 'EditCustomer',
    RegisterCustomer: 'RegisterCustomer',
    AuthorizeCustomer: 'AuthorizeCustomer',
    OrderAction: 'OrderAction',
    CreateAuthorizedOrder: 'CreateAuthorizedOrder',
    UpdateOrderStatus: 'UpdateOrderStatus',
    CreateorUpdateAuthorizedOrder: 'CreateorUpdateAuthorizedOrder',
};

module.exports = mindboxEvents;
